export interface NpiChecklist {
    id?: number;
    project: number;
    project_name?: string;
    part_numbers?: string[];
    active?: boolean;
}

export enum NpiChecklistPhaseStatus {
    COMPLETED = "completed",
    IN_PROGRESS = "in_progress",
    PENDING = "pending"
}

export interface NpiChecklistPhase {
    id: number;
    checklist: number;
    name: string;
    start_date: string | null;
    end_date: string | null;
    order: number;
    status: NpiChecklistPhaseStatus;
}

export interface NpiChecklistPartNumber {
    id: number;
    checklist: number;
    part_number: string;
    board: string;
}

export interface NpiChecklistProject {
    id: number;
    name: string;
    client: number;
}

export interface NpiChecklistStatusSummary {
    complete: number;
    on_going: number;
    at_risk: number;
    not_applicable: number;
}

export type NpiChecklistProgressSummary = Omit<NpiChecklistStatusSummary, "not_applicable">;

export interface NpiChecklistOverview {
    id: number;
    project: NpiChecklistProject;
    oem: string;
    odm: string;
    pcba_rev: string;
    kick_off_date: string | null;
    part_numbers: NpiChecklistPartNumber[];
    phases: NpiChecklistPhase[];
    total_items: number;
    total_items_completed: number;
    total_items_on_going: number;
    total_items_pending: number;
    total_items_not_applied: number;
    items_percent: NpiChecklistStatusSummary;
    progress_percent: NpiChecklistProgressSummary;
}
